import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, vShow as _vShow, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6e5ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card mb-4 mb-md-0" }
const _hoisted_4 = { class: "card-header border-0 pt-6" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Design ")
const _hoisted_12 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_13 = { class: "card-toolbar w-100" }
const _hoisted_14 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_15 = { class: "me-auto" }
const _hoisted_16 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1))
const _hoisted_18 = { class: "fw-bolder mx-5" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_21 = { class: "card-header border-0 pt-6" }
const _hoisted_22 = { class: "card-title w-100" }
const _hoisted_23 = { class: "row w-100" }
const _hoisted_24 = { class: "col-md-12 d-flex align-items-center position-relative my-1" }
const _hoisted_25 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_26 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_27 = { class: "card-toolbar" }
const _hoisted_28 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_29 = {
  key: 0,
  class: "card-body pt-0 d-none d-md-block"
}
const _hoisted_30 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = { style: { color: '#2c2c2c' } }
const _hoisted_34 = ["href"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-front p-0" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-slash-minus p-0" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "d-md-none d-block" }
const _hoisted_51 = {
  key: 0,
  class: "card"
}
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" to add new design ")
const _hoisted_55 = { class: "card-header ribbon" }
const _hoisted_56 = { class: "card-title" }
const _hoisted_57 = { class: "ribbon-label bg-info" }
const _hoisted_58 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1))
const _hoisted_60 = { class: "flex-grow-1" }
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = ["href"]
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "ms-4" }
const _hoisted_65 = {
  key: 0,
  class: "text-muted fw-bold d-block"
}
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Final Cost: ")
const _hoisted_67 = { style: { color: '#2c2c2c' } }
const _hoisted_68 = { class: "text-muted fw-bold d-block" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Remark: ")
const _hoisted_70 = { style: { marginTop: '0px' } }
const _hoisted_71 = { style: { color: '#2c2c2c' } }
const _hoisted_72 = { class: "card-footer d-flex justify-content-center pt-5" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-front p-0" }, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-slash-minus p-0" }, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "d-flex justify-content-center pt-5 pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_PartyMultiselect = _resolveComponent("PartyMultiselect")!
  const _component_SeasonMultiselect = _resolveComponent("SeasonMultiselect")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.hasCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addDesign()))
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
                  ]),
                  _hoisted_11
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllDesign) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllDesign]
                ]),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectAllDesign ? _ctx.total : _ctx.checkedDesign.length), 1),
              _hoisted_20
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.name) = $event)),
                type: "text",
                class: "form-control w-100 me-2",
                placeholder: "Search By Name"
              }, null, 512), [
                [_vModelText, _ctx.searchData.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_PartyMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.party_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchData.party_id) = $event)),
                class: "form-control"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_SeasonMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.season_id,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchData.season_id) = $event)),
                class: "form-control"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchItems()))
            }, " Search "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearFilter()))
            }, " Clear ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.selectAllDesign)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_31))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkedDesign) = $event))
                      }, null, 8, _hoisted_32)), [
                        [_vModelCheckbox, _ctx.checkedDesign]
                      ])
                ])
              ]),
              "cell-code": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.code), 1)
              ]),
              "cell-finalCost": _withCtx(({ row: site }) => [
                _createElementVNode("strong", _hoisted_33, "₹ " + _toDisplayString(site.finalCost), 1)
              ]),
              "cell-type": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.type), 1)
              ]),
              "cell-remark": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.remark), 1)
              ]),
              "cell-totalMaterialCost": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.totalMaterialCost), 1)
              ]),
              "cell-totalCuttingTime": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.totalCuttingTime), 1)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-image": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    href: site.image,
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      class: "img-thumbnail",
                      src: site.image,
                      style: {"max-height":"150px"}
                    }, null, 8, _hoisted_35)
                  ], 8, _hoisted_34)
                ])
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_36, [
                  (_ctx.hasEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.addDesign(site.id))
                      }, _hoisted_39, 8, _hoisted_37))
                    : _createCommentVNode("", true),
                  (_ctx.hasCreate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.cloneDesignHandler(site.id))
                      }, _hoisted_42, 8, _hoisted_40))
                    : _createCommentVNode("", true),
                  (_ctx.hasDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-danger btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.deleteDesignItem(site))
                      }, _hoisted_45, 8, _hoisted_43))
                    : _createCommentVNode("", true),
                  (_ctx.hasStock)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "btn btn-info btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.stockDesignItem(site.id))
                      }, _hoisted_48, 8, _hoisted_46))
                    : _createCommentVNode("", true),
                  (_ctx.hasMaterial)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        type: "button",
                        class: "btn btn-info btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.materialDesignItem(site.id))
                      }, " Materials ", 8, _hoisted_49))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addDesign({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_54
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h3", _hoisted_56, _toDisplayString(item.code), 1),
              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      target: "blank",
                      href: item.image ? item.image : 'media/logos/logo.png'
                    }, [
                      _createElementVNode("img", {
                        style: {
                        width: '100px',
                        height: '100px',
                        'margin-right': '12px',
                      },
                        src: item.image ? item.image : 'media/logos/logo.png',
                        alt: ""
                      }, null, 8, _hoisted_63)
                    ], 8, _hoisted_62)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    (_ctx.hasCost)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("strong", _hoisted_67, "₹ " + _toDisplayString(item.finalCost), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("strong", _hoisted_71, _toDisplayString(item.remark), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              (_ctx.hasEdit)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary mx-2 w-100",
                    onClick: ($event: any) => (_ctx.addDesign(item.id))
                  }, _hoisted_75, 8, _hoisted_73))
                : _createCommentVNode("", true),
              (_ctx.hasDelete)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-danger mx-2 w-100",
                    onClick: ($event: any) => (_ctx.deleteDesignItem(item))
                  }, _hoisted_78, 8, _hoisted_76))
                : _createCommentVNode("", true),
              (_ctx.hasCreate)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-primary btn-sm mx-2",
                    onClick: ($event: any) => (_ctx.cloneDesignHandler(item.id))
                  }, _hoisted_81, 8, _hoisted_79))
                : _createCommentVNode("", true),
              (_ctx.hasStock)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn-info mx-2 w-100",
                    onClick: ($event: any) => (_ctx.stockDesignItem(item.id))
                  }, _hoisted_84, 8, _hoisted_82))
                : _createCommentVNode("", true),
              (_ctx.hasMaterial)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    type: "button",
                    class: "btn btn-info mx-2 w-100",
                    onClick: ($event: any) => (_ctx.materialDesignItem(item.id))
                  }, " Materials ", 8, _hoisted_85))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.currentPage,
          "onUpdate:current-page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentPage) = $event)),
          onCurrentChange: _ctx.onPageChange,
          "page-size": 10,
          layout: "prev, pager, next",
          total: _ctx.total,
          "hide-on-single-page": false,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "total"])
      ])
    ])
  ]))
}